/**
 * Utility functions to detect WebView environment and handle browser API availability
 */

/**
 * Detects if the app is running in a React Native WebView
 * @returns {boolean} true if running in WebView, false otherwise
 */
export const isWebView = () => {
  // Check for React Native WebView user agent
  const userAgent = navigator.userAgent || '';
  
  // Common WebView indicators
  const webViewIndicators = [
    'wv', // Android WebView
    'WebView', // Generic WebView
    'ReactNative', // React Native WebView
    'Mobile', // Mobile WebView
  ];
  
  return webViewIndicators.some(indicator => 
    userAgent.toLowerCase().includes(indicator.toLowerCase())
  );
};

/**
 * Checks if serviceWorker API is available
 * @returns {boolean} true if serviceWorker is available, false otherwise
 */
export const isServiceWorkerSupported = () => {
  return 'serviceWorker' in navigator && !isWebView();
};

/**
 * Safely executes serviceWorker operations with fallback
 * @param {Function} callback - Function to execute if serviceWorker is available
 * @param {Function} fallback - Optional fallback function if serviceWorker is not available
 */
export const safeServiceWorkerOperation = (callback, fallback = () => {}) => {
  if (isServiceWorkerSupported()) {
    try {
      callback();
    } catch (error) {
      console.warn('ServiceWorker operation failed:', error);
      fallback();
    }
  } else {
    console.log('ServiceWorker not supported in this environment');
    fallback();
  }
};

/**
 * Checks if Firebase messaging is supported in current environment
 * @returns {boolean} true if Firebase messaging is supported, false otherwise
 */
export const isFirebaseMessagingSupported = () => {
  return !isWebView() && 'serviceWorker' in navigator;
};
